import { render } from "./roteirizador-list.vue?vue&type=template&id=254270f4&scoped=true"
import script from "./roteirizador-list.vue?vue&type=script&lang=js"
export * from "./roteirizador-list.vue?vue&type=script&lang=js"

import "./roteirizador-list.vue?vue&type=style&index=0&id=254270f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254270f4"]])

export default __exports__